import script from "./PantallaProduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaProduccion.vue?vue&type=script&setup=true&lang=js"

import "./PantallaProduccion.vue?vue&type=style&index=0&id=7d7f0eac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7f0eac"]])

export default __exports__